import _objectSpread from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _defineProperty from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _createForOfIteratorHelper from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import e from "../../../../core/Error.js";
import t from "../../../../core/Logger.js";
import { isPowerOfTwo as r } from "../../../../core/mathUtils.js";
import { pt2px as n } from "../../../../core/screenUtils.js";
import { copyAndPremultiply as i } from "./color.js";
import { WGLGeometryType as o, VVType as s } from "./enums.js";
import { TextProperties as a } from "./SymbolProperties.js";
import c from "../../../webgl/Texture.js";
var u = t.getLogger("esri.views.2d.engine.webgl.Utils"),
    l = "geometry",
    f = "per_instance",
    d = "per_instance_vv",
    m = [{
  name: l,
  strideInBytes: 36,
  divisor: 0
}],
    p = [{
  name: l,
  strideInBytes: 32,
  divisor: 0
}],
    y = [{
  name: l,
  strideInBytes: 20,
  divisor: 0
}],
    g = [{
  name: l,
  strideInBytes: 12,
  divisor: 0
}],
    h = [{
  name: l,
  strideInBytes: 40,
  divisor: 0
}],
    w = [{
  name: l,
  strideInBytes: 36,
  divisor: 0
}],
    v = [{
  name: l,
  strideInBytes: 36,
  divisor: 0
}];

function S(e) {
  var t = {};

  var _iterator = _createForOfIteratorHelper(e),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _r = _step.value;
      t[_r.name] = _r.strideInBytes;
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return t;
}

var I = S(m),
    L = S(p),
    M = S(y),
    A = S(g),
    T = S(h),
    C = S(w),
    b = S(v);

function z(e, _ref) {
  var t = _ref.fill;

  switch (e) {
    case o.MARKER:
      return I;

    case o.FILL:
      return "dot-density" === t ? A : "simple" === t ? M : L;

    case o.LINE:
      return T;

    case o.TEXT:
      return C;

    case o.LABEL:
      return b;
  }
}

var x = [l],
    E = [l],
    F = [l],
    B = [l],
    D = [l];

function U(e) {
  switch (e) {
    case o.MARKER:
      return x;

    case o.FILL:
      return E;

    case o.LINE:
      return F;

    case o.TEXT:
      return B;

    case o.LABEL:
      return D;
  }
}

function j(e) {
  switch (e % 4) {
    case 0:
    case 2:
      return 4;

    case 1:
    case 3:
      return 1;
  }
}

function R(e, t) {
  switch (t % 4) {
    case 0:
    case 2:
      return new Uint32Array(Math.floor(e * t / 4));

    case 1:
    case 3:
      return new Uint8Array(e * t);
  }
}

function $(e, t) {
  switch (t % 4) {
    case 0:
    case 2:
      return new Uint32Array(e);

    case 1:
    case 3:
      return new Uint8Array(e);
  }
}

function N(e) {
  return a.pool.acquire(e.color ? i(e.color) : [255, 255, 255, 255], e.haloColor ? i(e.haloColor) : [255, 255, 255, 255], n(e.haloSize), n(e.font.size), e.angle * Math.PI / 180, e.xoffset / e.font.size, e.yoffset / e.font.size, "left" === e.horizontalAlignment ? 0 : "right" === e.horizontalAlignment ? 1 : .5, "top" === e.verticalAlignment ? 0 : "bottom" === e.verticalAlignment ? 1 : .5);
}

function O(e) {
  return null != e;
}

function P(e) {
  return "number" == typeof e;
}

function k(t) {
  switch (t) {
    case "butt":
      return 0;

    case "round":
      return 1;

    case "square":
      return 2;

    default:
      return u.error(new e("mapview-invalid-type", "Cap type ".concat(t, " is not a valid option. Defaulting to round"))), 1;
  }
}

function V(t) {
  switch (t) {
    case "miter":
      return 2;

    case "bevel":
      return 0;

    case "round":
      return 1;

    default:
      return u.error(new e("mapview-invalid-type", "Join type ".concat(t, " is not a valid option. Defaulting to round"))), 1;
  }
}

function q(e) {
  switch (e) {
    case "opacity":
      return s.OPACITY;

    case "color":
      return s.COLOR;

    case "rotation":
      return s.ROTATION;

    case "size":
      return s.SIZE;

    default:
      return u.error("Cannot interpret unknown vv: ".concat(e)), null;
  }
}

function K(e) {
  var t = e.transform,
      r = e.hasZ,
      n = e.hasM;
  return {
    transform: t,
    hasZ: r,
    hasM: n
  };
}

function X(e, t, r, n, i, o, s) {
  for (var _c in o) {
    var _t = o[_c].stride,
        _n = j(_t),
        _s = o[_c].data,
        _a = r[_c].data,
        _u = _t * i.vertexCount / _n,
        _l = _t * e / _n,
        _f = _t * i.vertexFrom / _n;

    for (var _e = 0; _e < _u; ++_e) {
      _a[_e + _l] = _s[_e + _f];
    }
  }

  var a = i.indexCount;

  for (var _c2 = 0; _c2 < a; ++_c2) {
    n[_c2 + t] = s[_c2 + i.indexFrom] - i.vertexFrom + e;
  }
}

var Z = _defineProperty({}, l, 35044);

function _(e, t) {
  var r = [];

  for (var _n2 = 0; _n2 < 5; ++_n2) {
    var _i = U(_n2),
        _o = {};

    var _iterator2 = _createForOfIteratorHelper(_i),
        _step2;

    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var _e2 = _step2.value;
        _o[_e2] = {
          data: t(_n2, _e2)
        };
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }

    r.push({
      data: e(_n2),
      buffers: _o
    });
  }

  return r;
}

function J(e, t) {
  var n, i;
  return r(t.width) && r(t.height) ? (n = !0, i = 9987) : (n = !1, i = 9729), new c(e, {
    target: 3553,
    pixelFormat: 6408,
    internalFormat: 6408,
    dataType: 5121,
    hasMipmap: n,
    samplingMode: i,
    wrapMode: 33071,
    flipped: !0
  }, t);
}

function Y(e) {
  return {
    vertexFrom: void 0,
    vertexTo: void 0,
    geometry: e
  };
}

function G(e) {
  switch (e) {
    case 5120:
    case 5121:
      return 1;

    case 5122:
    case 5123:
      return 2;

    case 5126:
    case 5124:
    case 5125:
      return 4;
  }
}

function H(t) {
  switch (t) {
    case 5121:
      return 1;

    case 32819:
      return 2;

    case 5126:
      return 4;

    default:
      return void u.error(new e("webgl-utils", "Unable to handle type ".concat(t)));
  }
}

function Q(t) {
  switch (t) {
    case 5121:
      return Uint8Array;

    case 32819:
      return Uint16Array;

    case 5126:
      return Float32Array;

    default:
      return void u.error(new e("webgl-utils", "Unable to handle type ".concat(t)));
  }
}

function W(e) {
  var t = {};

  var _loop = function _loop(_r2) {
    var n = e[_r2];
    var i = 0;
    t[_r2] = n.map(function (e) {
      var t = _objectSpread(_objectSpread({}, e), {}, {
        normalized: e.normalized || !1,
        divisor: e.divisor || 0,
        offset: i,
        stride: 0
      });

      return i += e.count * G(e.type), t;
    }), t[_r2].forEach(function (e) {
      return e.stride = i;
    });
  };

  for (var _r2 in e) {
    _loop(_r2);
  }

  return t;
}

var ee = function ee(e) {
  var t = new Map();

  for (var _r3 in e) {
    var _iterator3 = _createForOfIteratorHelper(e[_r3]),
        _step3;

    try {
      for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
        var _n3 = _step3.value;
        t.set(_n3.name, _n3.location);
      }
    } catch (err) {
      _iterator3.e(err);
    } finally {
      _iterator3.f();
    }
  }

  return t;
},
    te = function te(e) {
  var t = {};

  for (var _r4 in e) {
    var _n4 = e[_r4];
    t[_r4] = _n4.length ? _n4[0].stride : 0;
  }

  return t;
},
    re = new Map(),
    ne = function ne(e, t) {
  if (!re.has(e)) {
    var _r5 = W(t),
        _n5 = {
      strides: te(_r5),
      bufferLayouts: _r5,
      attributes: ee(t)
    };

    re.set(e, _n5);
  }

  return re.get(e);
};

function ie(e) {
  e(o.FILL), e(o.LINE), e(o.MARKER), e(o.TEXT), e(o.LABEL);
}

var oe = function oe(e) {
  return "path" in e && ge(e.path);
},
    se = function se(e) {
  return "url" in e && e.url || "imageData" in e && e.imageData;
},
    ae = function ae(e) {
  return "imageData" in e && e.imageData && "contentType" in e && e.contentType ? "data:".concat(e.contentType, ";base64,").concat(e.imageData) : "url" in e ? e.url : null;
},
    ce = function ce(e) {
  return "url" in e && e.url && e.url.includes(".gif") || "contentType" in e && "image/gif" === e.contentType || "imageData" in e && e.imageData.includes("data:image/gif");
},
    ue = function ue(e) {
  return "url" in e && e.url && e.url.includes(".png") || "contentType" in e && "image/png" === e.contentType || "imageData" in e && e.imageData.includes("data:image/png");
},
    le = function le(e) {
  return e.type && -1 !== e.type.toLowerCase().indexOf("3d");
};

function fe(e) {
  switch (e.type) {
    case "line":
      {
        var _t2 = e;
        return "CIMSolidStroke" === _t2.cim.type && !_t2.dashTemplate;
      }

    case "fill":
      return "CIMSolidFill" === e.cim.type;

    case "esriSFS":
      return "esriSFSSolid" === e.style || "esriSFSNull" === e.style;

    case "esriSLS":
      return "esriSLSSolid" === e.style || "esriSLSNull" === e.style;

    default:
      return !1;
  }
}

var de = function de(e) {
  return e.includes("data:image/svg+xml");
};

function me(e) {
  switch ("cim" in e ? e.cim.type : e.type) {
    case "esriSMS":
    case "esriPMS":
    case "CIMPointSymbol":
    case "CIMVectorMarker":
    case "CIMPictureMarker":
    case "CIMCharacterMarker":
      return !1;

    default:
      return !0;
  }
}

function pe(e) {
  var t = "maxVVSize" in e && e.maxVVSize,
      r = "width" in e && e.width || "size" in e && e.size || 0;
  return t || r;
}

function ye(e) {
  var t = [];

  for (var _r6 = 0; _r6 < e.length; _r6++) {
    t.push(e.charCodeAt(_r6));
  }

  return t;
}

var ge = function ge(e) {
  return !!e && (e = e.trim(), !!(/^[mzlhvcsqta]\s*[-+.0-9][^mlhvzcsqta]+/i.test(e) && /[\dz]$/i.test(e) && e.length > 4));
};

export { L as C_FILL_STRIDE_SPEC, A as C_FILL_STRIDE_SPEC_DD, M as C_FILL_STRIDE_SPEC_SIMPLE, p as C_FILL_VERTEX_DEF, g as C_FILL_VERTEX_DEF_DD, y as C_FILL_VERTEX_DEF_SIMPLE, I as C_ICON_STRIDE_SPEC, m as C_ICON_VERTEX_DEF, b as C_LABEL_STRIDE_SPEC, v as C_LABEL_VERTEX_DEF, T as C_LINE_STRIDE_SPEC, h as C_LINE_VERTEX_DEF, C as C_TEXT_STRIDE_SPEC, w as C_TEXT_VERTEX_DEF, l as C_VBO_GEOMETRY, Z as C_VBO_INFO, f as C_VBO_PERINSTANCE, d as C_VBO_PERINSTANCE_VV, R as allocateTypedArrayBuffer, $ as allocateTypedArrayBufferwithData, ye as charCodes, X as copyMeshData, _ as createGeometryData, ne as createProgramDescriptor, J as createTextureFromTexelData, ie as forEachGeometryType, Y as geometryToMappedGeometry, G as getBytes, k as getCapType, V as getJoinType, U as getNamedBuffers, pe as getPMSResourceSize, Q as getPixelArrayCtor, H as getPixelBytes, z as getStrides, N as getTextProperties, K as getTransformParams, ae as getUrl, q as getVVType, le as is3D, O as isDefined, ce as isGIF, se as isImageResource, P as isNumber, ue as isPNG, de as isSVGImage, oe as isSVGResource, fe as isSimple, ge as isValidSVG, me as shouldRepeat, j as strideToPackingFactor };